import { FABRIC_TYPE } from '../../canvas/constants/object-meta';

export const isTextFabricType = (type: string | undefined): boolean => {
  const t = type?.toLowerCase();
  return t === FABRIC_TYPE.iText || t === FABRIC_TYPE.textbox || t === 'itext';
};
